/**
 * Generates a cache key for conversation stream data
 */
export function getConversationCacheKey(agentExecutionId: string): string {
    return `conversation:${agentExecutionId}`;
}
